import { Box, Chip, Typography } from "@mui/material";
import React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";

interface MessageListEventProps {
  name: string;
  uiType: number;
  date?: number;
}

export const MessageListEvent = ({
    name,
    uiType,
    date,
}: MessageListEventProps) => (
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: ".5rem 0",
        }}
    >
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
            {Base.timeToDateTimeStr(date)}
        </Typography>
        <Chip
            label={
                uiType < 1.5
                    ? Translations.Published
                    : uiType < 2.5
                        ? Translations.Approved
                        : Translations.Closed
            }
            sx={{
                margin: "0 .5rem",
                backgroundColor: uiType < 1.5 ? "red" : uiType < 2.5 ? "#ffa800" : "#00bd00", // TODO: switch to theme colors
                color: "#fff",
            }}
        />
        <Typography variant="caption" sx={{ color: "text.secondary" }}>{name}</Typography>
    </Box>
);
